export default "__VITE_ASSET__Do6wJuh1__"